import AssistantsList from "../../components/AssistantsList";
import OpenAIMessage from "../../components/OpenAIMessage";
import { useTenant } from "../../providers/tenant";
import { useUser } from "../../providers/users";

const AssitantsPage = () => {
  const { tenantSettings } = useTenant();
  const { user, verifyRolePermission, roleAdmin } = useUser();

  const api_key = tenantSettings && tenantSettings.openai_api_key;
  return (
    <>
      {user &&
      verifyRolePermission(roleAdmin) === true &&
      (!api_key || api_key === null) ? (
        <OpenAIMessage />
      ) : (
        <AssistantsList />
      )}
    </>
  );
};

export default AssitantsPage;
